import React, { createContext, useContext, useState } from 'react';
import { fetchPostData } from '@/Components/hooks/Api';

const VehicleContext = createContext();

export const VehicleProvider = ({ children }) => {
  const [VehicleData, setVehicleData] = useState([]);
  const [VehicleFilterData, setVehicleFilterData] = useState([]);
  const [vehicleStatus, setVehicleStatus] = useState(false);
  const [vehicleCount, setVehicleCount] = useState('');
  const [VehicleSearch, setVehicleSearch] = useState([]);
  const [vehErrorStatus, setVehErrorStatus] = useState(false);

  const get_Data_Vehicle = (IncidentId) => {
    fetchPostData('PropertyVehicle/GetData_PropertyVehicle', { IncidentId }).then((res) => {
      setVehicleData(res || []);
      setVehicleFilterData(res || []);
    });
  };

  const get_vehicle_Count = (VehicleID, MasterPropertyID) => {
    const val = VehicleID
      ? { PropertyID: VehicleID, MasterPropertyID: 0, IsMaster: false }
      : { PropertyID: 0, MasterPropertyID, IsMaster: true };
    fetchPostData('HomeApi/GetData_VehicleCount', val).then((res) => {
      setVehicleCount(res?.[0] || '');
    });
  };

  return (
    <VehicleContext.Provider
      value={{
        VehicleData,
        setVehicleData,
        VehicleFilterData,
        setVehicleFilterData,
        vehicleStatus,
        setVehicleStatus,
        vehicleCount,
        setVehicleCount,
        VehicleSearch,
        setVehicleSearch,
        vehErrorStatus,
        setVehErrorStatus,
        get_Data_Vehicle,
        get_vehicle_Count,
      }}
    >
      {children}
    </VehicleContext.Provider>
  );
};

export const useVehicle = () => {
  const context = useContext(VehicleContext);
  if (!context) throw new Error('useVehicle must be used within VehicleProvider');
  return context;
};

export default VehicleContext;
